import React from "react";
import { useNavigate } from "react-router-dom";

import EvChargingImg from "../../../assets/ev.webp";
import { exploreSurveyIntentPath } from "../../../configs/ExploreSurveyConfig";
import { pageConfigBySlug } from "../../../services/nav/NavigationService";
import {
  IDashboardEvPayload,
  IDashboardTileResult,
} from "../../../services/zeos-api/contracts/Dashboard";
import { dashboardUnitOr } from "../../../services/helpers/DashboardTileHelpers";
import { DashboardMetricTile } from "../shared/DashboardMetricTile";

interface IProps {
  unlocked: boolean;
  setUnlocked: (unlocked: boolean) => void;
  hackStoneMill?: boolean | undefined;
  tileResult?: IDashboardTileResult<IDashboardEvPayload>;
  loading?: boolean;
}

export const EVCharging = (props: IProps) => {
  const navigate = useNavigate();
  const exploreSlug = pageConfigBySlug("explore")?.slug || "explore";
  const data = props.tileResult?.data;

  return (
    <DashboardMetricTile
      tileKey="ev"
      title="EV Charging"
      image={EvChargingImg}
      navPath={pageConfigBySlug("ev")?.slug || "ev"}
      unlocked={props.unlocked}
      setUnlocked={props.setUnlocked}
      tileResult={props.tileResult}
      loading={props.loading}
      lockedCopy={{
        bodyHeading: "PLUG INTO SAVINGS",
        bodyContent:
          "Adding EV Charging can enhance the value of your property and generate additional revenue.",
        onExploreClick: () =>
          navigate(exploreSurveyIntentPath(exploreSlug, "ev-charging")),
      }}
      metrics={[
        {
          label: "Energy",
          value: data?.evSupply,
          unit: dashboardUnitOr(data?.evSupplyUnit, "kWh"),
          tone: "positive",
        },
        {
          label: "Revenue",
          value: data?.evRevenue,
          unit: dashboardUnitOr(data?.evRevenueUnit, "$"),
          tone: "neutral",
        },
        // 4111: same names and figures as the EV detail page.
        {
          label: "Net Margin",
          value: data?.evNetMargin,
          unit: dashboardUnitOr(data?.evNetMarginUnit, "$"),
          tone: (data?.evNetMargin ?? 0) < 0 ? "neutral" : "positive",
        },
        {
          label: "Energy Cost",
          value: data?.evEnergyCost,
          unit: dashboardUnitOr(data?.evEnergyCostUnit, "$"),
          tone: "neutral",
        },
      ]}
    />
  );
};
